import Reveal from './Reveal';

const principals = [
  {
    id: 'kirk-mangum',
    initials: 'KM',
    name: 'Kirk Mangum',
    title: 'Principal',
    bio: 'Kirk joined the firm his father founded in 2003 and has led it since 2016. He holds a B.S.B.A. in Finance, Insurance and Real Estate and an M.S. in Accounting with a tax concentration, both from Appalachian State University. A licensed North Carolina real estate broker, he spent more than eight years practicing commercial real estate before joining the firm — experience that gives him a practical, big-picture view of how tax decisions shape property, investments, and business growth. Deeply involved in the Durham community through his church and several nonprofit boards, he is also an avid outdoorsman who has thru-hiked the 2,100-mile Appalachian Trail and served 28 years with the National Ski Patrol.',
  },
  {
    id: 'grant-mangum',
    initials: 'GM',
    name: 'Grant Mangum',
    title: 'Founder',
    bio: 'Grant founded the firm in 1966 and, for more than 55 years, successfully consulted hundreds of healthcare professionals across North Carolina, South Carolina, and Virginia. The trusted relationships he built — many spanning decades — remain the foundation of the practice today.',
  },
];

const staff = [
  { id: 'dona-braswell', initials: 'DB', name: 'Dona Braswell', title: 'CPA, Advisor' },
  { id: 'andy-huckins', initials: 'AH', name: 'Andy Huckins', title: 'CPA, Advisor' },
  { id: 'rachel-chang', initials: 'RC', name: 'Rachel Chang', title: 'EA, Advisor' },
  { id: 'karen-anderson', initials: 'KA', name: 'Karen Anderson', title: 'Bookkeeper' },
  { id: 'wendy-holliday', initials: 'WH', name: 'Wendy Holliday', title: 'Office Manager' },
  { id: 'barbara-field', initials: 'BF', name: 'Barbara Field', title: 'Administrator' },
];

function Medallion({ initials, size = 96, fontSize = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" aria-hidden="true" className="shrink-0">
      <circle cx="48" cy="48" r="45" fill="none" stroke="#C5A059" strokeWidth="1.5" />
      <circle cx="48" cy="48" r="38" fill="none" stroke="#C5A059" strokeWidth="0.75" opacity="0.5" />
      <text x="48" y="57" textAnchor="middle" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize={fontSize} letterSpacing="2" fill="#C5A059">{initials}</text>
    </svg>
  );
}

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="bg-navy py-28 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            <span className="eyebrow-rule" />
            Our team
          </p>
          <h2 data-testid="team-heading" className="font-serif tracking-tight text-cream text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.08]">
            The people behind <span className="italic text-gold-light">the practice.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid lg:grid-cols-2 gap-px bg-cream/10 border border-cream/10">
          {principals.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.12} className="h-full">
              <article data-testid={`team-member-${p.id}`} className="group bg-navy h-full p-10 lg:p-14 transition-colors duration-500 hover:bg-navy-light/60">
                <Medallion initials={p.initials} />
                <h3 className="font-serif text-cream text-3xl tracking-tight mt-8">{p.name}</h3>
                <p className="text-xs tracking-[0.3em] uppercase text-gold mt-3">{p.title}</p>
                <p className="mt-6 text-cream/65 font-light leading-relaxed text-sm lg:text-base">{p.bio}</p>
                <span className="mt-8 block w-8 h-px bg-gold transition-all duration-500 group-hover:w-full" aria-hidden="true" />
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10">
          {staff.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.06}>
              <div data-testid={`team-member-${s.id}`} className="text-center">
                <div className="flex justify-center">
                  <Medallion initials={s.initials} size={72} fontSize={20} />
                </div>
                <h3 className="font-serif text-cream text-lg tracking-tight mt-5">{s.name}</h3>
                <p className="text-[10px] tracking-[0.25em] uppercase text-gold/90 mt-2">{s.title}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
